<template>
    <div class="param-validation">
        <h4 class="text-left mb-3 check-heading">
            <h1>Offenes Seminar</h1>
            <span
                style=""
                :class="{ 'text-danger': errors.length > 0 }"
            >
                <i
                    class="material-icons"
                    v-if="errors.length === 0"
                >check_circle</i>
                <i
                    v-else
                    class="material-icons"
                >cancel</i>
            </span>
            Überprüfung der Angebots-Parameter
        </h4>
        <b-row>
            <b-col
                v-for="(item, index) in checked"
                :key="index"
                :md="4"
                class="mb-3"
            >
                <b-card class="condensed-card">
                    <div
                        class="validation-indicator"
                        :class="{
                            'text-success': item.success,
                            'text-danger': !item.success,
                        }"
                    >
                        <i
                            class="material-icons"
                            v-if="item.success"
                        >check_circle</i>
                        <i
                            v-else
                            class="material-icons"
                        >cancel</i>
                    </div>
                    <b-card-body>
                        <b-card-title>
                            {{ item.description }}
                            <small>{{ formatParamValue(item) }}</small>
                        </b-card-title>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>

import { get } from 'core-js/core/dict';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import {
    languageFromCombitFlag,
    offerLanguageLabelFromCombitFlag,
} from '../misc/CombitOfferLanguage';

export default {
    name: 'OfferParamsOpenSeminar',
    data: function () {
        return {
            loading: false,
            errors: [],
            checked: [],
            offerTypeIds: {
                2: 4,
                3: 1,
                4: 2,
                6: 3,
            },
        };
    },
    computed: {
        ...mapGetters([
            'company',
            'contact',
            'seminar',
            'trainer',
            'employee',
            'offer',
            'offerType',
            'hashParams',
            'hasHashParams',
            'seminarDate',
        ])
    },
    async mounted() {
        let offerParams = {}
        for (const param of this.paramLoaders()) {
            const value = param.getValue();
            this.validateParamValue(param, { value, result: null });
            if (this.hasErrors(param.name)) {
                this.checked = [...this.checked, { ...param, success: false, value }]
                continue;
            }
            if (param.getResult) {
                try {
                    await param.getResult(value);
                } catch (err) {
                    console.error('Error getting Result for ' + param.name);
                    console.error(err);
                }
                this.validateParamResult(param, { value, result: this[param.prop] });
            }
            if (!this.hasErrors(param.name) && param.onSuccess) {
                offerParams[param.name] = param.onSuccess({ value, result: (param.prop) ? this[param.prop] : null })
            }
            this.checked = [...this.checked, { ...param, success: !this.hasErrors(param.name), value }]
        }
        this.$emit('loaded', { params: this.hashParams, values: offerParams, errors: this.errors, valid: this.errors.length === 0 })
    },
    methods: {
        ...mapActions([
            'fetchCompany',
            'fetchContact',
            'fetchSeminarDate',
            'fetchSeminar',
            'fetchTrainer',
            'fetchEmployee',
            'fetchOfferType',
        ]),
        ...mapMutations([
            'offerSet',
            'clearHashParams',
        ]),
        formatParamValue({ name, value, success }) {
            if (value === null) {
                return "-";
            }
            if (name === "language" && success) {
                return offerLanguageLabelFromCombitFlag(value);
            }
            return value;
        },
        validateParamValue(param, value) {
            const validations = (param.validations && param.validations.checkBefore)
                ? param.validations.checkBefore
                : [];
            this.validate(param.name, validations, value);
        },
        validateParamResult(param, result) {
            const validations = (param.validations && param.validations.checkAfter)
                ? param.validations.checkAfter
                : [];
            this.validate(param.name, validations, result);
        },
        validate(name, validations, { value, result }) {
            this.errors = [
                ...this.errors,
                ...validations.reduce((acc, cur) => (acc.length > 0 && acc[acc.length - 1].stopValidationOnError) //if last check was stop item
                    ? acc
                    : !cur.condition({ value, result })
                        ? [...acc, cur]
                        : acc
                    , [])
                    .map(validation => {
                        return {
                            name,
                            message: validation.message({ value, result }),
                            value
                        }
                    })
            ];
        },
        hasErrors(paramName) {
            return this.errors.filter(err => err.name === paramName).length > 0
        },
        errorsByName(paramName) {
            return this.errors.filter(err => err.name === paramName)
        },
        decodeUri(str) {
            //return decodeURIComponent((str+'').replace(/\+/g, '%20'));
            return decodeURIComponent((str + ''));
        },
        mapPriceToInt(pricePosition) {
            return { ...pricePosition, price: parseInt(pricePosition.price) };
        },
        paramLoaders() {
            return [
                {
                    name: 'language',
                    description: 'Angebotssprache',
                    getValue: () => Object.prototype.hasOwnProperty.call(this.hashParams, 'isEnglishOffer')
                        ? this.decodeUri(this.hashParams.isEnglishOffer)
                        : undefined,
                    validations: {
                        checkBefore: [
                            {
                                condition: ({ value }) => {
                                    try { languageFromCombitFlag(value); return true; } catch (error) { return false; }
                                },
                                message: ({ value }) => `isEnglishOffer muss "true" oder "false" sein; übergeben wurde "${value}".`
                            },
                        ]
                    },
                    onSuccess: ({ value }) => languageFromCombitFlag(value)
                },
                {
                    name: 'company_id',
                    description: 'Kunden-ID',
                    getValue: () => this.hashParams.companyId ? this.decodeUri(this.hashParams.companyId) : null,
                    getResult: (value) => this.fetchCompany(value),
                    validations: {
                        checkBefore: [
                            { condition: ({ value }) => value && value !== '', message: () => 'Keine Firmen-ID übergeben.' },
                        ],
                        checkAfter: [
                            { condition: ({ result }) => result && result.id, message: ({ value }) => `Die Firma mit der ID "${value}" konnte nicht gefunden werden` }
                        ]
                    },
                    prop: 'company',
                    onSuccess: ({ result }) => result.id
                },
                {
                    name: 'contact_id',
                    description: 'Kontakt-ID',
                    getValue: () => this.hashParams.contactId ? this.decodeUri(this.hashParams.contactId) : null,
                    getResult: (value) => this.fetchContact(this.company.ref_id + '_' + value),
                    validations: {
                        checkBefore: [
                            { condition: ({ value }) => value && value !== '', message: () => 'Keine Kontakt-ID übergeben.' },
                            { condition: () => this.company && this.company.ref_id, message: () => 'Ohne zugehörige Firma kann der Kontakt nicht ermittelt werden.' },
                        ],
                        checkAfter: [
                            { condition: ({ result }) => result && result.id, message: ({ value }) => `Kontakt mit der ID "${this.company.ref_id + '_' + value}" konnte nicht gefunden werden.` }
                        ]
                    },
                    prop: 'contact',
                    onSuccess: ({ result }) => result.id
                },
                {
                    name: 'seminarDate_id',
                    description: 'Termin-ID',
                    getValue: () => this.hashParams.seminarDateId ? this.decodeUri(this.hashParams.seminarDateId) : null,
                    getResult: (value) => this.fetchSeminarDate(value),
                    validations: {
                        checkBefore: [
                            { condition: ({ value }) => value && value !== '', message: () => 'Keine Termin-ID übergeben.' },
                        ],
                        checkAfter: [
                            {
                                condition: ({ result }) => {
                                    console.log(`result here`, result);
                                    return result && result.id
                                }
                                , message: ({ value }) => `Termin mit der ID ${value} nicht gefunden.`
                            },
                        ]
                    },
                    prop: 'seminarDate',
                    onSuccess: ({ result }) => result.id
                },
                {
                    name: 'employee_id',
                    description: 'E-Mail des Erstellers',
                    getValue: () => this.hashParams.authorId ? this.decodeUri(this.hashParams.authorId) : null,
                    getResult: (value) => this.fetchEmployee(value),
                    validations: {
                        checkBefore: [
                            { condition: ({ value }) => value && value !== '', message: () => 'Die E-Mail des Erstellers des Angebots wurde nicht übergeben.' },
                            { condition: ({ value }) => typeof value === 'string' && value.match(/.+@gfu\.net/i), message: ({ value }) => `Die übergebene E-Mail des Erstellers "${value}" ist keine gültige GFU-Mailaddresse.` }
                        ],
                        checkAfter: [
                            { condition: ({ result }) => result && result.id, message: ({ value }) => `Mitarbeiter mit der E-Mail "${value}" konnte nicht gefunden werden.` }
                        ]
                    },
                    prop: 'employee',
                    onSuccess: ({ result }) => result.id
                },
                {
                    name: 'offerType_id',
                    description: 'Seminartyp-ID',
                    getValue: () => this.hashParams.offerTypeId ? this.decodeUri(this.hashParams.offerTypeId) : 2,
                    getResult: (value) => this.fetchOfferType(this.offerTypeIds[parseInt(value)]),
                    validations: {
                        checkBefore: [
                            {
                                condition: ({ value }) => parseInt(value) === 2,
                                message: ({ value }) => `Die übergebene Seminartyp-ID "${value}" ist nicht gültig. Nur "2" ist erlaubt (Offenes Angebot).`
                            }
                        ],
                        checkAfter: [
                            { condition: ({ result }) => result && result.id, message: ({ value }) => `Der Angebots-Typ für die ID "${this.offerTypeIds[value]}" konnte nicht gefunden werden.` }
                        ]
                    },
                    prop: 'offerType',
                    onSuccess: ({ result }) => {
                        console.log(`result`);
                        console.log(result)
                        return result.id
                    }
                },


                {
                    name: 'numberOfParticipants',
                    description: 'Teilnehmerzahl',
                    getValue: () => this.hashParams.numberOfParticipants ? this.decodeUri(this.hashParams.numberOfParticipants) : null,
                    validations: {
                        checkBefore: [
                            { condition: ({ value }) => value && value !== '', message: () => 'Die Anzahl Teilnehmer wurde nicht übergeben.' },
                            {
                                condition: ({ value }) => value && !Number.isNaN(parseInt(value)) && parseInt(value) > 0,
                                message: () => 'Die Anzahl Teilnehmer muss ein positiver Integerwert sein.'
                            },
                        ]
                    },
                    onSuccess: ({ value }) => value
                },
                //SeminarDate "Nach Absprache", ja oder nein

                {
                    name: 'offerNumber',
                    description: 'Angebotsnummer',
                    getValue: () => this.hashParams.offerNumber ? this.decodeUri(this.hashParams.offerNumber) : null,
                    validations: {
                        checkBefore: [
                            { condition: ({ value }) => value && value !== '', message: () => 'Die Angebotsnummer wurde nicht übergeben.' },
                        ]
                    },
                    onSuccess: ({ value }) => value
                },
                {
                    name: 'combitId',
                    description: 'Combit-ID',
                    getValue: () => this.hashParams.offerId ? this.decodeUri(this.hashParams.offerId) : null,
                    validations: {
                        checkBefore: [
                            { condition: ({ value }) => value && value !== '', message: () => 'Die Angebots-ID (offerId) wurde nicht übergeben.' },
                        ]
                    },
                    onSuccess: ({ value }) => value
                },
                {
                    name: 'hash',
                    description: 'Angebots-ID',
                    getValue: () => this.hashParams.urlHash ? this.decodeUri(this.hashParams.urlHash) : null,
                    validations: {
                        checkBefore: [
                            { condition: ({ value }) => value && value !== '', message: () => 'Der URL-Hash wurde nicht übergeben.' },
                        ]
                    },
                    onSuccess: ({ value }) => value
                },
                {
                    name: 'totalPrice',
                    description: 'Gesamtpreis',
                    getValue: () => this.hashParams.totalPrice ? this.decodeUri(this.hashParams.totalPrice) : null,
                    validations: {
                        checkBefore: [
                            { condition: ({ value }) => value && value !== '', message: () => 'Der Gesamtpreis des Angebots wurde nicht übergeben.' },
                            {
                                condition: ({ value }) => value && !Number.isNaN(parseInt(value)) && parseInt(value) > 0,
                                message: () => 'Der Gesamtpreis des Angebots muss ein positiver Integerwert sein.'
                            },
                        ]
                    },
                    onSuccess: ({ value }) => value
                },
                {
                    name: 'isClassroom',
                    description: 'Präsenz-Schulung',
                    getValue: () => this.hashParams.isclassroom ? this.decodeUri(this.hashParams.isclassroom) : 'false',
                    validations: {
                        checkBefore: [
                            {
                                condition: ({ value }) => value && ['true', 'false'].includes(value),
                                message: () => 'Die Angabe, ob es sich um eine Präsenzschulung handelt (isClassroom) muss entweder "true" oder "false" sein.'
                            },
                        ]
                    },
                    onSuccess: ({ value }) => value === 'true' ? 1 : 0
                },
                {
                    name: 'isRemote',
                    description: 'Remote-Schulung',
                    getValue: () => this.hashParams.isremote ? this.decodeUri(this.hashParams.isremote) : 'false',
                    validations: {
                        checkBefore: [
                            {
                                condition: ({ value }) => value && ['true', 'false'].includes(value),
                                message: () => 'Die Angabe, ob es sich um ein Remoteseminar handelt (isRemote) muss entweder "true" oder "false" sein.'
                            },
                        ]
                    },
                    onSuccess: ({ value }) => value === 'true' ? 1 : 0
                },
                //SeminarDate "Nach Absprache", ja oder nein
                {
                    name: 'seminarDateTbd',
                    description: 'Datum Nach Absprache',
                    getValue: () => this.hashParams.seminarDateTbd ? this.decodeUri(this.hashParams.seminarDateTbd) : 'false',
                    validations: {
                        checkBefore: [
                            {
                                condition: ({ value }) => value && ['true', 'false'].includes(value),
                                message: () => 'Die Angabe, ob es sich um ein Remoteseminar handelt (isRemote) muss entweder "true" oder "false" sein.'
                            },
                        ]
                    },
                    onSuccess: ({ value }) => value === 'true' ? 1 : 0
                },
                {
                    name: 'additionalCostsBase64',
                    description: 'Zusätzliche Kosten Base64',
                    getValue: () => (this.hashParams.additionalCostsBase64 && this.hashParams.additionalCostsBase64.trim() !== '') ? this.hashParams.additionalCostsBase64 : null,
                    validations: {
                        checkBefore: [
                            {
                                condition: ({ value }) => { //if value is a valid base64 string
                                    try {
                                        window.atob(value);
                                        return true;
                                    } catch (err) {
                                        return false;
                                    }
                                },
                                message: ({ value }) => `Die zusätzlichen kosten sind nicht Base64 kodiert." `,
                                stopValidationOnError: true,
                            }
                        ]
                    }
                },
                {
                    name: 'additionalCosts',
                    description: 'Zusätzliche Kosten',
                    getValue: () => (this.hashParams.additionalCosts && this.hashParams.additionalCosts.trim() !== '') ? this.hashParams.additionalCosts : "[]",
                    validations: {
                        checkBefore: [
                            {
                                condition: ({ value }) => !this.errors.some(({ name }) => { console.log(name); return name === 'additionalCostsBase64' }),
                                message: ({ value }) => `Falsche kodierung siehe oben`,
                                stopValidationOnError: true,
                            },
                            {
                                condition: ({ value }) => { //if value is a valid json encoded array
                                    try {
                                        return Array.isArray(JSON.parse(value));
                                    } catch (err) {
                                        return false;
                                    }
                                },
                                message: ({ value }) => `Die zusätzlichen kosten sind nicht JSON kodiert.`,
                                stopValidationOnError: true,
                            },
                            // {
                            //   condition: ({value}) => JSON.parse(value) // check if have price position not integer
                            //     .every(({price}) => !(price + '').includes('.')),
                            //   message: ({value}) => `Die Preise der zusätzlichen Kosten müssen als ganze Zahlen angegeben werden: ` + JSON.parse(value)
                            //       .filter(({price}) => (price + '').includes('.'))
                            //       .map(({description, price}) => `Die Position "${description}" hat den ungültigen Preis ${price}.`)
                            //       .join(' '),
                            //   stopValidationOnError: true,
                            // }
                        ]
                    },
                    onSuccess: ({ value }) => JSON.parse(value).map(this.mapPriceToInt),
                },
            ]
        },
    }
}
</script>

<style>
.list-group-item {
    padding: 0 1.25em;
    background-color: initial;
    border: none
}

.xl-content {
    line-break: anywhere;
}

.condensed-card {
    padding: 10px 15px;
}

.condensed-card .card-title {
    font-size: 1.2em;
    margin-bottom: 0px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: calc(100% - 50px);
}

.condensed-card .card-title small {
    font-weight: bold;
    font-size: .8em;
}

.validation-indicator {
    position: absolute;
    right: 10px;
    top: 7.5px;
    font-size: 20px;
}

.check-heading .material-icons,
.debug-heading .material-icons {
    vertical-align: text-top;
    font-size: 1.1em;

}

.debug-link:hover h6 {
    color: #333 !important;
}
</style>
